import { AfterViewInit, Component, EventEmitter, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { AlertClassColour, ApplicationNames, ConfigSystemParams, msSize, OurColors } from 'src/app/core/consts';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { catchError, throwError } from 'rxjs';
import { CompaniesService } from 'src/app/core/services/utelize/system/company/companies-service';
import { CompanyDTO } from 'src/app/core/models/system/company/company.dto';
import { CompletedModalFormComponent } from 'src/app/forms-modal/_pop-ups/completed-modal-form/completed-modal-form.component';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { ConfirmationModalFormComponent } from '../../_pop-ups/confirmation-modal-form/confirmation-modal-form.component';
import { DropdownService } from 'src/app/core/services/utelize/general/dropdown-service';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Guid } from 'guid-typescript';
import { LastPassKillerService } from 'src/app/core/services/utelize/general/last-pass-killer-service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { SystemUserDTO } from 'src/app/core/models/system/user/system-user.dto';
import { WarningModalFormComponent } from 'src/app/forms-modal/_pop-ups/warning-modal-form/warning-modal-form.component';

@Component({
  selector: 'app-company-modal-form-more',
  templateUrl: './company-modal-form-more.component.html',
  styleUrls: ['./company-modal-form-more.component.scss']
})

export class CompanyModalFormMoreComponent implements AfterViewInit, OnDestroy, OnInit {
  
  @Output() moreFormCancelled   : EventEmitter<boolean>=new EventEmitter<boolean>();
  @Output() moreFormHasBeenSaved: EventEmitter<void>   =new EventEmitter<void>();

  @ViewChild('companyModalFormMore',         { static: false }) moreFormModal!               : TemplateRef<void>;
  @ViewChild('completedModalForm',           { static: false }) completedModalForm!          : CompletedModalFormComponent;
  @ViewChild('killCompanyConfirmationModal', { static: false }) killCompanyConfirmationModal!: ConfirmationModalFormComponent;
  @ViewChild('warningModalForm',             { static: false }) warningModalForm!            : WarningModalFormComponent;
    
  get isOwnCompany       () { return this.sureSimCompany?.id===this.curUser.companyId             ; }
  get killCompanyDisabled() { return !this.killCompanyEnabled || this.isOwnCompany                ; }
  get killCompanyHint    () { return this.isOwnCompany ? "You cannot remove your own company" : ""; }

  get modalBackGround() { let value: string | boolean=this.configSystemService.getValue(ConfigSystemParams.ModalBackGround, "TRUE");
                          return value=value.toUpperCase()=="STATIC" ? "static" : (value.toUpperCase()=="TRUE" ? true : false) }
  
  private initialStatus         : string="Please select an operation";
  private kill_SS_OnlyNewValue  : boolean=false;
  private kill_SS_OnlyOldValue  : boolean=false;
  private moreFormModalRef!     : NgbModalRef;
  private sureSimCompany        : CompanyDTO | undefined;
  private sureSimCompanyID      : number | undefined;
   
  public alertColourProgress    : string=AlertClassColour.Green;
  public curUser                : SystemUserDTO;
  public formSubmitted          : boolean=false;
  public highlightBtnKillCompany: boolean=false;
  public killCompanyEnabled     : boolean=false;
  public moreForm!              : UntypedFormGroup;
  public progressInformation    : string=this.initialStatus;
  public submitButtonEnabled    : boolean=false;
  public formTitle              : string="Company Operations";

  constructor(
    private authenticationService: AuthenticationService,
    private companiesService     : CompaniesService,
    private configSystemService  : ConfigSystemService,
    private dropdownService      : DropdownService,
    private exceptionsService    : ExceptionsService,
    private formBuilder          : UntypedFormBuilder,
    private lastPassKillerService: LastPassKillerService,
    private modalService         : NgbModal
  ) {
      this.curUser=this.authenticationService.currentUserObject();
  }
  
  public ngOnInit(): void {
    try {
      
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public ngAfterViewInit(): void {
    try {
      this.lastPassKillerService.start();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public ngOnDestroy(): void {
    try {
      this.lastPassKillerService.stop();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public resetMainVariables(): void {
    try {
      this.alertColourProgress =AlertClassColour.Green;
      this.formSubmitted       =false;
      this.killCompanyEnabled  =this.configSystemService.getValueAsBoolean(ConfigSystemParams.KillCompaniesAndUsers, false) &&
                                this.curUser.systemAdmin;
      this.kill_SS_OnlyNewValue=this.configSystemService.getValueAsBoolean(ConfigSystemParams.KillCompaniesAndUsersSureSimOnly, false);
      this.kill_SS_OnlyOldValue=this.kill_SS_OnlyNewValue;
      this.progressInformation =this.initialStatus;
      this.submitButtonEnabled =false;
      this.sureSimCompany      =undefined;
      this.sureSimCompanyID    =undefined;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public openForm(sureSimCompanyID: number): void {
    try {
      this.resetMainVariables();
      this.setUpForm();
      
      if (sureSimCompanyID==undefined || <number>sureSimCompanyID<=0)
        throw new Error("CompanyModalFormMoreComponent..SureSIM CompanyID cannot be determined");

      this.sureSimCompanyID=sureSimCompanyID;

      this.getSureSimCompanyAndOpenModal();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private openModal(): void {
    try {
      this.moreFormModalRef=this.modalService.open(this.moreFormModal, { backdrop: this.modalBackGround,
                                                                         centered: true,
                                                                         keyboard: false,
                                                                         size    : msSize.Medium });
    }
    catch(e) {
      this.moreFormCancelled.emit();
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region moreForm
  
  get formOfOrderDetails() {
    return this.moreForm.controls;
  }
  
  get formOfMore() {
    return this.moreForm.controls;
  }
    
  private setUpForm() {
    try {
      this.buildForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private buildForm() {
    try {
      this.removeFormFields(this.moreForm);
       this.moreForm=this.formBuilder.group({ });
      
      this.addFormFields(this.moreForm);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  private addFormFields(formGroup: UntypedFormGroup) {
    try {
      if (formGroup==this.moreForm) {
        this.addFormControl(formGroup, "companyId",       "",    []);
        this.addFormControl(formGroup, "companyName",     "",    []);
        this.addFormControl(formGroup, "inviewCompanyId", "",    []);
        this.addFormControl(formGroup, "killSureSimOnly", false, []);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private addFormControl(form      : UntypedFormGroup,
                         dataField : string,
                         value     : boolean | string,
                         validators: Validators) {
    try {
      form.addControl(dataField, new FormControl(
        value,
        validators
      ));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  private removeFormFields(form: UntypedFormGroup) {
    try {
      if (form != undefined) {
        for (let control in form.controls) {
          form.removeControl(control);
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  private populateFormFields(formGroup: UntypedFormGroup) {
    try {
      if (formGroup==this.moreForm) {
        this.moreForm.controls["companyId"].setValue(this.sureSimCompany?.id);
        this.moreForm.controls["companyName"].setValue(this.sureSimCompany?.companyName);
        this.moreForm.controls["inviewCompanyId"].setValue(this.sureSimCompany?.inviewCompanyID);
        this.moreForm.controls["killSureSimOnly"].setValue(this.kill_SS_OnlyOldValue);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private enableDisableControls(enabled: boolean) {
    try {
      
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  public moreFormSubmit() {
    try {
      this.formSubmitted=true;
      
      if (this.moreForm.valid) {
        
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  public moreFormCancel() {
    try {
      if (this.kill_SS_OnlyNewValue != this.kill_SS_OnlyOldValue) {
        this.setConfigSystemParamValue(ConfigSystemParams.KillCompaniesAndUsersSureSimOnly, this.kill_SS_OnlyOldValue ? "TRUE" : "FALSE");
      }
      
      this.moreFormCancelled.emit();
      this.moreFormModalRef.close();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  //#endregion
  
  public getSureSimCompanyAndOpenModal() {
    try {
      this.companiesService.getById(<number>this.sureSimCompanyID)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.sureSimCompany=data;
          this.populateFormFields(this.moreForm);
          this.openModal();
        },
        error: error => {
          this.moreFormCancelled.emit();
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  //#region KillCompany

  public killCompany() {
    try {
      if (this.isOwnCompany)
        return;

      this.killCompanyConfirmationModal.openForm("WARNING",
                                                 `Are you sure you want to completely remove this company AND any associated users from ${ApplicationNames.SureSIM} and ${ApplicationNames.InviewApi}?`,
                                                 undefined,
                                                 OurColors.Red,
                                                 OurColors.DarkBlue);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public yesKillCompany() {
    try {
      this.killCompanyEnabled=false;

      this.companiesService.killCompany(<Guid>this.sureSimCompany?.guid)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.killCompanyEnabled=true;

          if (data.result) {
            this.completedModalForm.openForm("Complete",
                                             "The company has been removed",
                                             "https://cdn.lordicon.com/ypnsnhgh.json",
                                             OurColors.Red,
                                             OurColors.DarkBlue);

            this.dropdownService.trackerCompanyId=this.curUser?.companyId;

          } else {
            this.warningModalForm.openForm("Warning", "The company could not be removed");
          }
        },
        error: error => {
          this.killCompanyEnabled=true;
          
          this.moreFormCancelled.emit();
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public killCompanyMouseLeave() {
    try {
      this.highlightBtnKillCompany=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public killCompanyMouseOver() {
    try {
      this.highlightBtnKillCompany=true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public killSureSimOnlyClick() {
    try {
      this.killCompanyEnabled  =false;
      this.kill_SS_OnlyNewValue=!this.moreForm.get("killSureSimOnly")?.value;

      this.setConfigSystemParamValue(ConfigSystemParams.KillCompaniesAndUsersSureSimOnly, this.kill_SS_OnlyNewValue ? "TRUE" : "FALSE");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region ConfigSystem
  
  public setConfigSystemParamValue(param: string, value: string) {
    try {
      this.configSystemService.setValue(param, value)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.killCompanyEnabled=true;
        },
        error: error => {
          this.killCompanyEnabled=true;
          this.moreFormCancelled.emit();
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion
  
  public completedModalHasBeenClosed() {
    try {
      if (this.kill_SS_OnlyNewValue != this.kill_SS_OnlyOldValue) {
        this.setConfigSystemParamValue(ConfigSystemParams.KillCompaniesAndUsersSureSimOnly, this.kill_SS_OnlyOldValue ? "TRUE" : "FALSE");
      }

      this.moreFormHasBeenSaved.emit();
      this.moreFormModalRef.close();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
}
